import { media } from 'ia-react-core';
import styled, { createGlobalStyle } from 'styled-components';

export const InformativeMessageGlobalStyles = createGlobalStyle`
  #InformativeMessage-StyledIconDiv {
    margin-right: 0;
    color: ${({ theme }) => theme.colors.teal7};
    margin-bottom: 12px;
    text-align: center;
    ${media.sm`
      margin-bottom: 0;
      margin-right: 12px;
      text-align: left;
      float: left;
    `}
  }

  #InformativeMessage-StyledDiv {
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.29;
    letter-spacing: normal;
    text-align: center;
    margin:auto;
    ${media.md`
      text-align: left;   
    `}
    ${media.sm`
      margin-left: 60px;
    `}
  }
`;

export const StyledAside = styled.aside`
  background: ${({ theme }) => theme.colors.white};
  padding: 4px 32px 24px 32px;
  display: inherit;
  border-bottom-color: ${({ theme }) => theme.colors.gray3};
  border-bottom-style: solid;
  border-bottom-width: 1px;
  ${media.sm`
    display: flex;
  `}
`;

export const StyledDiv = styled.div`
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  margin:auto;  
  ${media.md`
    text-align: left;
    margin:0;    
  `}   
 `;

export const StyledContainer = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: 20px 0 0 0;
  border-radius: 4px 4px 0 0;
 `;

export const StyledSitecoreMessage = styled.div` 
  display: inline-block;  
  padding-top: 0px;
`;
